/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type PayerEntryConfigSortKey = typeof PayerEntryConfigSortKey[keyof typeof PayerEntryConfigSortKey];


export const PayerEntryConfigSortKey = {
  PayerName: 'PayerName',
  Pinned: 'Pinned',
} as const;
